import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewFixed from "./View";
import {getValetContractInvoice, lineItemsApprovalRejection} from "../../../../../../services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
    lineItemsApprovalRejectionResponse: state.postSalesReducer.lineItemsApprovalRejectionResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetContractInvoice,
            lineItemsApprovalRejection
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewFixed);
